<template>
  <div id="insideRecommend">
    <!-- 周年卡 -->
    <div class="container" v-if="type == 2">
      <typeOne></typeOne>
    </div>
    <!-- 荣耀卡 -->
    <div class="container" v-if="type == 3">
      <typeTwo></typeTwo>
    </div>
    <!-- 勋章卡 -->
    <div class="container" v-if="type == 1">
      <typeThree></typeThree>
    </div>
    <!-- 公益 -->
    <div class="container" v-if="type == 4">
      <typeFour></typeFour>
    </div>
  </div>
</template>

<script>
import typeOne from "./type1/index.vue";
import typeTwo from "./type2/index.vue";
import typeThree from "./type3/index.vue";
import typeFour from "./type4/index.vue";
export default {
  components: {
    typeOne,
    typeTwo,
    typeThree,
    typeFour
  },
  data() {
    return {
      type:'',
    };
  },
  mounted() {
    //获取勋章类型
    this.type=this.$route.query.type
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #insideRecommend {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #insideRecommend {
    width: 276px * $zoom;
  }
}
#insideRecommend {
  font-size: 16px * $zoom;
  height: 100vh;
  position: relative;
  .container {
    width: 100%;
    height: 100%;
  }
}
</style>
